// Webpack Imports
import * as bootstrap from 'bootstrap';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	const im = iframemanager();
	const cc = initCookieConsent();

	im.run({
		currLang: 'de',
		autoLang: false,
		onChange: ({ changedServices, eventSource }) => {
			if(eventSource.type === 'click') {
				cc.accept('functional');
			}
		},
		services : {
			youtube : {
				embedUrl: 'https://www.youtube-nocookie.com/embed/{data-id}',
				thumbnailUrl: 'https://i3.ytimg.com/vi/{data-id}/hqdefault.jpg',
				iframe : {
					allow : 'accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen;',
					onload : function(data_id, callback){
						console.log("loaded iframe with data-id=" + data_id);
					}
				},
				languages : {
					de: {
						notice: 'Mit dem Aufruf des Videos erklären Sie sich einverstanden, dass Ihre Daten an YouTube übermittelt werden und dass Sie die <a rel="noreferrer noopener" href="https://www.youtube.com/t/terms" target="_blank">Datenschutzerklärung</a> von YouTube gelesen haben.',
						loadBtn: 'Video laden',
						loadAllBtn: "Nicht nachfragen"
					},
					en : {
						notice: 'This content is hosted by a third party. By showing the external content you accept the <a rel="noreferrer noopener" href="https://www.youtube.com/t/terms" target="_blank">terms and conditions</a> of youtube.com.',
						loadBtn: 'Load video',
						loadAllBtn: "Don't ask again"
					}
				}
			},
			googlemaps : {
				embedUrl: 'https://www.google.com/maps/embed?pb={data-id}',
				iframe : {
					allow : 'picture-in-picture; fullscreen;'
				},
				languages : {
					de : {
						notice: 'Mit dem Aufruf der Karte erklären Sie sich einverstanden, dass Ihre Daten an Google übermittelt werden und dass Sie die <a href="https://policies.google.com/privacy" target="_blank" title="https://policies.google.com/privacy">Datenschutzerklärung</a> von Google gelesen haben.',
						loadBtn: 'Karte laden',
						loadAllBtn: "Nicht nachfragen"
					},
					en : {
						notice: 'This content is hosted by a third party. By showing the external content you accept the <a rel="noreferrer noopener" href="https://www.youtube.com/t/terms" target="_blank">terms and conditions</a> of google.com.',
						loadBtn: 'Load map',
						loadAllBtn: "Don't ask again"
					}
				}
			},
		}
	});

	cc.run({
		current_lang: 'de',
		autoclear_cookies: true,                   // default: false
		page_scripts: true,                        // default: false

		// mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
		// delay: 0,                               // default: 0
		// auto_language: null                     // default: null; could also be 'browser' or 'document'
		// autorun: true,                          // default: true
		// force_consent: false,                   // default: false
		// hide_from_bots: true,                   // default: true
		// remove_cookie_tables: false             // default: false
		// cookie_name: 'cc_cookie',               // default: 'cc_cookie'
		// cookie_expiration: 182,                 // default: 182 (days)
		// cookie_necessary_only_expiration: 182   // default: disabled
		// cookie_domain: location.hostname,       // default: current domain
		// cookie_path: '/',                       // default: root
		// cookie_same_site: 'Lax',                // default: 'Lax'
		// use_rfc_cookie: false,                  // default: false
		// revision: 0,                            // default: 0

		gui_options: {
			consent_modal: {
				layout: 'box',               // box/cloud/bar
				position: 'bottom left',     // bottom/middle/top + left/right/center
				transition: 'slide',           // zoom/slide
				swap_buttons: false            // enable to invert buttons
			},
			settings_modal: {
				layout: 'box',                 // box/bar
				position: 'left',           		// left/right
				transition: 'slide'            // zoom/slide
			}
		},

		onFirstAction: function(user_preferences, cookie){

		},

		onAccept: function (cookie) {
			if(cookie.categories.includes('functional')) {
				if(im.getState().services.has('googlemaps')) im.acceptService('googlemaps');
				if(im.getState().services.has('youtube')) im.acceptService('youtube');
			}
		},

		onChange: function (cookie, changed_preferences) {
			if(!cookie.categories.includes('functional')) {
				cc.eraseCookies(['im_youtube', 'im_googlemaps'])
			}

			if(!cookie.categories.includes('marketing')) {

			}
		},

		languages: {
			'de': {
				consent_modal: {
					title: 'Diese Webseite benutzt Cookies 📢',
					description: 'Wir nutzen Cookies auf unserer Webseite. Einige sind notwendig, während andere uns helfen, diese Webseite und Ihre Erfahrung zu verbessern. <button type="button" data-cc="c-settings" class="cc-link">Individuelle Cookie-Einstellungen</button>',
					primary_btn: {
						text: 'Alle akzeptieren',
						role: 'accept_all'              // 'accept_selected' or 'accept_all'
					},
					secondary_btn: {
						text: 'Alle ablehnen',
						role: 'accept_necessary'        // 'settings' or 'accept_necessary'
					}
				},
				settings_modal: {
					title: 'Cookie-Einstellungen',
					save_settings_btn: 'Einstellungen speichern',
					accept_all_btn: 'Alle akzeptieren',
					reject_all_btn: 'Alle ablehnen',
					close_btn_label: 'Schließen',
					blocks: [
						{
							title: 'Verwendung von Cookies 📢',
							description: 'Wir verwenden Cookies, um Ihnen ein optimales Webseiten-Erlebnis zu bieten. Wir setzen auf unserer Website Cookies ein. Einige von ihnen sind notwendig, während andere nicht notwendig sind, uns helfen unser Onlineangebot zu verbessern und wirtschaftlich zu betreiben. Sie können in den Einsatz der nicht notwendigen Cookies mit dem Klick auf die Schaltfläche <span class="font-weight-bold">"Alle Akzeptieren"</span> einwilligen oder per Klick auf <span class="font-weight-bold">"Alle ablehnen"</span> sich anders entscheiden. Die Einwilligung umfasst alle vorausgewählten, bzw. von Ihnen ausgewählten Cookies. Sie können diese Einstellungen jederzeit aufrufen und Cookies auch nachträglich jederzeit abwählen (in der Datenschutzerklärung und im Fußbereich unserer Website). <br><br>Wenn Sie unter 16 Jahre alt sind und Ihre Zustimmung zu freiwilligen Diensten geben möchten, müssen Sie Ihre Erziehungsberechtigten um Erlaubnis bitten.'
						},
						{
							title: 'Essenziell',
							description: 'Essential Services sind für die grundlegende Funktionalität der Website erforderlich. Sie enthalten nur technisch notwendige Services. Diesen Services kann nicht widersprochen werden.',
							toggle: {
								value: 'necessary',
								enabled: true,
								readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
							}
						},
						{
							title: 'Funktional',
							description: 'Funktionale Services sind notwendig, um über die wesentliche Funktionalität hinausgehende Features wie schönere Schriftarten, Videowiedergabe oder interaktive Web 2.0-Features bereitzustellen. Inhalte von z.B. Videoplattformen und Social Media Plattformen sind standardmäßig gesperrt und können erlaubt werden. Wenn dem Service zugestimmt wird, werden diese Inhalte automatisch ohne weitere manuelle Einwilligung geladen.',
							toggle: {
								value: 'functional',     // your cookie category
								enabled: false,
								readonly: false
							},
						},
						{
							title: 'Marketing',
							description: 'Marketing Services werden von uns und Dritten genutzt, um das Verhalten einzelner Nutzer aufzuzeichnen, die gesammelten Daten zu analysieren und z.B. personalisierte Werbung anzuzeigen. Diese Services ermöglichen es uns, Nutzer über mehrere Websites hinweg zu verfolgen.',
							toggle: {
								value: 'marketing',
								enabled: false,
								readonly: false
							}
						},
						{
							title: 'Mehr Informationen',
							description: 'Weitere Informationen über die Verwendung Ihrer Daten finden Sie in unserer <a href="/datenschutzerklaerung" class="cc-link">Datenschutzerklärung</a>. Sie können Ihre Auswahl jederzeit in der <a href="/datenschutzerklaerung" class="cc-link">Datenschutzerklärung</a> widerrufen oder anpassen.',
						}
					]
				}
			},
		}
	});



} )();